module.exports = __webpack_public_path__ + "static/img/qrcode.7741f61d.svg";